import styled from 'styled-components';

import Arrow from 'assets/icons/arrows/arrow-down-16.svg';

import Identicon from 'basics/Identicon';

import { cardBoxShadow, flexRowSpaceBetween, respondDown, respondUp } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const Container = styled.div<{ $isSelected: boolean }>`
    display: flex;
    flex-direction: column;
    background-color: ${COLORS.surface};
    ${cardBoxShadow};
    padding: 2.4rem;
    border-radius: 2.4rem;
    margin-bottom: 2.4rem;
    cursor: pointer;
    border: ${({ $isSelected }) =>
        `0.2rem solid ${$isSelected ? COLORS.purple500 : COLORS.transparent}`};
    position: relative;

    ${respondDown(Breakpoints.lg)`
        padding: 1.6rem;
    `}
`;

export const Image = styled.img`
    height: 4.8rem;
    width: 4.8rem;
    border-radius: 50%;
    margin-right: 1.6rem;
`;

export const Main = styled.div<{ $isSelected: boolean }>`
    display: flex;
    flex-direction: column;

    ${respondDown(Breakpoints.lg)`
        flex-direction: column;
        border-bottom: ${({ $isSelected }) =>
            $isSelected ? `0.1rem solid ${COLORS.gray50}` : 'none'};
        padding-bottom: ${({ $isSelected }) => ($isSelected ? '2.4rem' : '0')};
    `}
`;

export const Header = styled.div`
    display: flex;
    align-items: center;

    h3 {
        font-weight: 700;
        font-size: 1.6rem;
        line-height: 2.8rem;
        color: ${COLORS.textPrimary};
        display: flex;
        gap: 0.8rem;
        align-items: center;

        div {
            height: fit-content;
        }
    }

    span {
        margin-left: auto;
        color: ${COLORS.textGray};
    }

    b {
        color: ${COLORS.textPrimary};
    }

    ${respondDown(Breakpoints.lg)`
        span {
            display: none;
        }
    `};

    ${respondDown(Breakpoints.xs)`
        h3 {
            flex-direction: column;
            align-items: flex-start;
            gap: 0;
        }
    `};
`;

export const MobileAmount = styled.span`
    margin-top: 1.6rem;
    ${respondUp(Breakpoints.lg)`
        display: none;
    `}
`;

export const Bio = styled.p`
    margin-top: 2.4rem;
    color: ${COLORS.textGray};
    margin-bottom: 0;
`;

export const Trusted = styled.span`
    color: ${COLORS.textGray};
`;

export const AffiliateProject = styled.span`
    color: ${COLORS.textGray};

    b {
        color: ${COLORS.textPrimary};
    }
`;

export const ArrowIcon = styled(Arrow)<{ $isSelected: boolean }>`
    display: none;
    transform: rotate(${({ $isSelected }) => ($isSelected ? '180deg' : '0')});
    transition: transform 0.2s;
    margin-left: auto;

    ${respondDown(Breakpoints.lg)`
        display: flex;
    `}
`;

export const IdenticonStyled = styled(Identicon)`
    height: 4.8rem;
    width: 4.8rem;
    margin-right: 0.8rem;
`;
export const BottomRow = styled.div`
    ${flexRowSpaceBetween};
    margin-top: 2.4rem;

    ${respondDown(Breakpoints.md)`
        flex-direction: column;
        align-items: flex-start;
        gap: 1.6rem;
    `}
`;
